/* tslint:disable */
/* eslint-disable */

/**
 * Time format of the emails (12-hour, e.g. 1:30 PM, or 24-hour, e.g. 13:30).
 */
export enum EmailTimeFormat {
  Hour12 = 'HOUR_12',
  Hour24 = 'HOUR_24'
}
